import {
  useDisclosure,
  useToken,
  Box,
  Drawer,
  DrawerOverlay,
  DrawerContent,
  DrawerCloseButton,
  Flex,
} from '@chakra-ui/react';
import { FaInfoCircle } from 'react-icons/fa';

import { PropsWithChildren } from 'lib/@types';

export interface MobileTooltipProps extends PropsWithChildren {
  showBackground?: boolean;
}

export const MobileTooltip = ({
  children,
  showBackground = true,
  ...props
}: MobileTooltipProps) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const grey900 = useToken('colors', 'grey.900');

  return (
    <>
      <Box {...props}>
        <FaInfoCircle
          cursor='pointer'
          color={grey900}
          onClick={(event) => {
            event.stopPropagation();
            onOpen();
          }}
        />
      </Box>
      <Drawer placement='bottom' onClose={onClose} isOpen={isOpen}>
        <DrawerOverlay
          background={showBackground ? 'blackAlpha.600' : 'none'}
        />

        <DrawerContent backgroundColor='primary.500' p={2.5}>
          <Flex
            flexDirection='row'
            justifyContent='space-between'
            alignItems='center'
          >
            {children}
            <DrawerCloseButton color='white.100' position='static' />
          </Flex>
        </DrawerContent>
      </Drawer>
    </>
  );
};
